<template>
  <div class="tab-body">
   
    <div class="dataTable autoFlex" v-if="listData">
      <el-table
        class="table"
        :data="listData.records"
        stripe
        border
        height="auto"
        v-loading="listLoading"
      >
        <el-table-column
          type="selection"
          width="55"
          fixed="left"
        ></el-table-column>
         <el-table-column prop="title" width="400px" label="规章制度名称"> 
          <template slot-scope="scope">
            <div>《 {{scope.row.title}} 》</div>
          </template></el-table-column>
        <el-table-column prop="starttm" width="110" label="开始生效"></el-table-column>
        <el-table-column prop="endtm" width="110" label="有效期至"></el-table-column>
        <el-table-column width="110" prop="level" label="类型"></el-table-column>
        <el-table-column label="操作" fixed="right" >
          <template slot-scope="scope">
            <div class="dataTable-operator">
              <el-button
                size="mini"
                @click="toDetail(scope.$index, scope.row)"
                >查看详情</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pageBar">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :total="listData.total"
          :page-size="page.size"
          :current-page="page.current"
          :layout="this.$constant.page.layout"
          :page-sizes="this.$constant.page.pageSizes"
        ></el-pagination>
      </div>
    </div>
	<detail ref="detail"></detail>
  </div>
</template>
<script>

import detail from "./detail.vue";
import api from "@/api/oa/ossdoc.js";
export default {
  name: "ossdoc",
  components: {
	detail
  },
  data() {
    return {
      searchParams: {},
      listData: [],
      listLoading: false,
      page: new this.$constant.pageObj(),
    };
  },
  methods: {
    //获取数据
    list() {
      this.listLoading = true;
      let params = this.$utils.merger(this.searchParams, this.page);
      params.type = 1
      api.lsdocs(params, (response) => {
        this.listData = response.data;
        this.listLoading = false;
      });
    },
   
    //去详情
    toDetail(index, row) {
      this.$refs.detail.open(row, row.title, true);
    },    //改变每页显示数量
    sizeChange(val) {
      this.page.size = val;
      this.list();
    },
    //改变现在的页码
    currentChange(val) {
      this.page.current = val;
      this.list();
    },
     
  },
  mounted() {
    this.list();
  },
};
</script>

<style lang="scss" scoped="scoped">
   @import "~common/custom/css/common.scss";
</style>

